export const badgeObject = [
  {
    src: require("../image/firstPost.png"),
    alt: "첫게시글",
    content: "첫게시글",
  },
  {
    src: require("../image/localMerchant.png"),
    alt: "게시글5개이상",
    content: "우리동네 렌탈업자",
  },
  {
    src: require("../image/firstTrade.png"),
    alt: "렌트예약 첫 등록",
    content: "렌트예약 첫 등록",
  },
  {
    src: require("../image/manyTrader.png"),
    alt: "빌린 물건 5회",
    content: "빌려볼리티",
  },
  {
    src: require("../image/manners.png"),
    alt: "매너온도 37.5도 이상",
    content: "매너러블",
  },
  {
    src: require("../image/hardTalker.png"),
    alt: "채팅50회 이상",
    content: "달변가",
  },
  {
    src: require("../image/rentOrNot.png"),
    alt: "찜 10개 이상",
    content: "빌릴까말까",
  },
  {
    src: require("../image/reporter.png"),
    alt: "신고 1회",
    content: "투철한 신고정신",
  },
  {
    src: require("../image/photographer.png"),
    alt: "한 게시물에 10개 이상의 사진",
    content: "열정사진사",
  },
];
